import React from 'react';
import { Link } from 'react-router-dom';

const SqlReportsTable = ({
  sqlReports,
  handleDownload,
  handleRun,
  handleGSheet,
}) => {
  const renderTableRow = ({ id, title }) => {
    return (
      <tr key={id}>
        <td>{id}</td>
        <td>{title}</td>
        <td>
          <Link to={`/reporting/automated-reports/${id}/view`}>
            <button className="btn btn-default">View</button>
          </Link>
        </td>
        <td style={{ minWidth: '340px' }}>
          <button
            onClick={() => handleDownload(id)}
            className="btn btn-default mar-r"
          >
            Download
          </button>
          <button
            onClick={() => handleRun(id)}
            className="btn btn-default mar-r"
          >
            Run
          </button>
          <button onClick={() => handleGSheet(id)} className="btn btn-default">
            Export to GSheets
          </button>
        </td>
      </tr>
    );
  };

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Id</th>
          <th>Title</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>{sqlReports.map(renderTableRow)}</tbody>
    </table>
  );
};

export default SqlReportsTable;
